<div class="card sidenav no-padding padding-bottom">
	<!-- <div class="logo margin-bottom-large padding-left padding-right">
		<img src="assets/img/logo.jpg" />
	</div> -->

	@for (group of sidenavGroups; track group; let first = $first) {
		<ng-container>
			<div class="menu">
				@for (item of group.groupItems; track item) {
					<div
						class="item flex padding-small center"
						[ngClass]="{ selected: group.groupUrlPart === currentGroupUrlPart && item.menuRoute === currentItemUrlPart }"
						(click)="onClickItem(group, item)"
						*btHasRole="item.requiredRoles">
						<i [ngClass]="item.icon" class="margin-right-small"></i>

						<div class="label flex-1" [title]="item.menuLabel">{{ item.menuLabel }}</div>
					</div>
				}
			</div>
		</ng-container>
	}
</div>
